import React__default from 'react';
import { Box, Grid } from '@mui/material';

var SearchPageLayout = function (_a) {
    var searchHeader = _a.searchHeader, searchResults = _a.searchResults, searchResultsStyle = _a.searchResultsStyle, businessFilters = _a.businessFilters, children = _a.children, templateFooter = _a.templateFooter;
    return (React__default.createElement(React__default.Fragment, null,
        children,
        searchHeader,
        React__default.createElement(Box, { id: "DataViewAndFilters", className: "DataViewAndFilters", sx: {
                display: "flex",
                flexGrow: 1,
                maxWidth: "100vw",
                overflowX: "hidden"
            } },
            React__default.createElement(Box, { sx: {
                    minHeight: "100%"
                } }, businessFilters),
            React__default.createElement(Grid, { sx: {
                    minHeight: "100%",
                    overflowX: "auto"
                }, container: true },
                React__default.createElement(Grid, { item: true, xs: 12, md: 12, style: searchResultsStyle },
                    React__default.createElement(Box, { sx: { height: "100%" } }, searchResults)))),
        templateFooter));
};

export { SearchPageLayout as default };
//# sourceMappingURL=SearchPageLayout.js.map
